import app from 'flarum/forum/app';
import { adoptChannelPayload } from './invitations';

/**
 * Transferência de canal para outro membro, em três passos no servidor (ver
 * Service\OwnershipTransfers): o dono inicia e recebe um código por e-mail,
 * confirma o código, e o membro aceita ou recusa. Cada passo devolve o canal e os
 * membros, que vão para o store. O código não é guardado nem logado aqui.
 */

async function transferRequest(channelId, step, attributes) {
  if (attributes === void 0) {
    attributes = {};
  }
  const payload = await app.request({
    method: 'POST',
    url: "".concat(app.forum.attribute('apiUrl'), "/chat-channels/").concat(channelId, "/transfer").concat(step),
    body: {
      data: {
        attributes
      }
    },
    // Quem chama mostra a resposta do servidor (código errado diz quantas
    // tentativas restam); o alerta padrão do core duplicaria a mensagem.
    errorHandler: () => undefined
  });
  return adoptChannelPayload(payload);
}
export function startTransfer(channelId, userId) {
  return transferRequest(channelId, '', {
    userId
  });
}
export function confirmTransfer(channelId, code) {
  return transferRequest(channelId, '/confirm', {
    code
  });
}
export function cancelTransfer(channelId) {
  return transferRequest(channelId, '/cancel');
}
export function acceptTransfer(channelId) {
  return transferRequest(channelId, '/accept');
}
export function declineTransfer(channelId) {
  return transferRequest(channelId, '/decline');
}
flarum.reg.add('ramon-chat', 'forum/utils/transfers', { startTransfer: startTransfer,confirmTransfer: confirmTransfer,cancelTransfer: cancelTransfer,acceptTransfer: acceptTransfer,declineTransfer: declineTransfer, });